import React from 'react'
import EyRnButton from '../../../../components/EyRnButton/EyRnButton';
import styles from './AIChatModels.module.scss';

export default function AIChatModels({ selectedRoom }: any) {
  const chatModels = [
    {
      id: "y878e4",
      text: "Show me how to mitigate these risks",
      room: "room1",
    },
    {
      id: "y989gugu4",
      text: "What risks should I be focusing on?",
      room: "room2",
    },
    {
      id: "ftr69ugu4",
      text: "Create a presentation for the board",
      room: "room3",
    },
    {
      id: "dSA89gu4",
      text: "Add this group of risks to an audit",
      room: "room4",
    },
    {
      id: "AUDITK0659",
      text: "Create a report for these risks",
      room: "room5",
    },
  ];

  return (
    <>
      <div className="text-center mv-4">
        <EyRnButton size={53} />
        <h3 className="fw-300 mt-4 text-gray-25">
          What can I help you with today?
        </h3>
      </div>

      <div className={styles.modelContainer}>
        {chatModels.map((model) => (
          <div key={model.id} onClick={() => selectedRoom(model)} className={styles.pill}>
            {model.text}
            <i className="icon-arrow-right"></i>
          </div>
        ))}
      </div>
    </>
  );
}
